import React from "react";
import { ImageTile, ListTile, ListTileItem, TitleContainer } from "../../";

const HouseTypeRoot = (props) => {
	const { handleClick, houseTypes, parentSelection } = props;

	const maxReached =
		Array.isArray(parentSelection.selection) &&
		parentSelection.maxSelect > 1 &&
		parentSelection.selection.length >= parentSelection.maxSelect;

	return (
		<TitleContainer title="Haustyp">
			<ListTile>
				{houseTypes
					? houseTypes.map((layout, index) => (
							<ListTileItem
								key={`element-${layout.id}`}
								index={index}
								length={houseTypes.length}
							>
								<ImageTile
									disabled={
										maxReached && !parentSelection.selection.includes(layout.id)
									}
									handleClick={() => handleClick(layout.id)}
									index={index}
									isSelected={parentSelection.selection.includes(layout.id)}
									node={layout}
								/>
							</ListTileItem>
						))
					: null}
				<ListTileItem
					key={`element-${houseTypes.length + 1}`}
					index={houseTypes.length + 1}
					length={houseTypes.length}
				>
					<ImageTile
						disabled={false}
						handleClick={() =>
							window.open(
								"https://www.hausconcept.ch/sie-wuenschen/individuelle-mfh/",
								"_blank",
							)
						}
						index={houseTypes.length + 1}
						node={{
							title: "Mehrfamilienhaus",
							images: ["images/static/MFH.png"],
							description: "Concept-Mehrfamilienhäuser von Hausconcept",
						}}
					/>
				</ListTileItem>
			</ListTile>
		</TitleContainer>
	);
};

export default HouseTypeRoot;



// WEBPACK FOOTER //
// ./src/modules/houseType/components/houseTypeRoot.jsx